import {
    EhrUnpaidRenderedServiceListQuery,
    EhrUnpaidRenderedServiceListResponse,
    EhrUnpaidCountData,
    EhrUnpaidCountResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/ehr-unpaid-rendered-service';

export class EhrUnpaidRenderedServiceApi {
    public static async getList(
        params: EhrUnpaidRenderedServiceListQuery,
    ): Promise<EhrUnpaidRenderedServiceListResponse> {
        const res = await axios.get<EhrUnpaidRenderedServiceListResponse>(BASE_URL, { params });
        return res.data;
    }

    public static async getEhrCount(ehrIds: string[]): Promise<EhrUnpaidCountData[]> {
        const res = await axios.get<EhrUnpaidCountResponse>(`${BASE_URL}/count`, {
            params: { ehrId: ehrIds.join(',') },
        });
        return res.data.ehrCounts;
    }
}
